import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

export type SortKey = 'recommended' | 'price-asc' | 'price-desc' | 'newest';

interface SortOption {
  key: SortKey;
  label: string;
}

@Component({
  selector: 'app-category-sort-bar',
  templateUrl: './category-sort-bar.component.html',
  styleUrls: ['./category-sort-bar.component.scss']
})
export class CategorySortBarComponent {
  @Input() count = 0;
  @Input() currentSort: SortKey = 'recommended';
  @Output() sortChange = new EventEmitter<SortKey>();

  readonly options: SortOption[] = [
    { key: 'recommended', label: $localize`:@@category.sort.recommended:推薦` },
    { key: 'price-asc',   label: $localize`:@@category.sort.priceAsc:價格：由低至高` },
    { key: 'price-desc',  label: $localize`:@@category.sort.priceDesc:價格：由高至低` },
    { key: 'newest',      label: $localize`:@@category.sort.newest:最新` }
  ];

  isOpen = false;

  constructor(private elRef: ElementRef<HTMLElement>) {}

  get currentLabel(): string {
    return this.options.find(o => o.key === this.currentSort)?.label ?? this.options[0].label;
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  select(option: SortOption): void {
    this.isOpen = false;
    if (option.key !== this.currentSort) {
      this.sortChange.emit(option.key);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen) return;
    if (!this.elRef.nativeElement.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen = false;
  }
}
